






















import useAssignChat from "@/composables/v3/useAssignChat";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { isChatAssignedToMeV21, shouldAssignV21 } from "@/utils/chats";
import { defineComponent } from "@vue/composition-api";
import { UseTimeAgo } from "@vueuse/components";
import { BAlert, BAvatar, BBadge, BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAlert,
        BButton,
        BAvatar,
        BBadge,
        UseTimeAgo,
    },
    setup() {
        const chatsStore = useChatsStore();
        const channelsStore = useChannelsStore();

        const { assignToMe } = useAssignChat();

        return {
            channelsStore,
            chatsStore,
            isChatAssignedToMeV21,
            shouldAssignV21,
            assignToMe,
        };
    },
});
